import type { PageComponent } from '@/core/features/a-dynamic-page/dynamic-page-pacts/dynamic-page-type';

import { usePartialComponentQueries } from '@/core/features/a-component/hooks/use-component-queries';

/**
 * Re-fetches all dynamic page components marked with the loading state
 * partial via the components endpoint.
 *
 * @returns A list of all partial components, now containing their partial data and eventually updated data.
 */
export function useDynamicPagePartialComponents(components: PageComponent[]): {
    partialComponents: PageComponent[];
} {
    const partialComponentsQueries = usePartialComponentQueries(components);

    const partialComponents = partialComponentsQueries.reduce<PageComponent[]>((acc, componentQuery) => {
        // Typescript helper: Will never happen, because all partialComponentQueries have defaultData defined
        if (!componentQuery.data) {
            return acc;
        }

        acc.push(componentQuery.data);
        return acc;
    }, []);

    return { partialComponents };
}
